<template>
	<div id="streamProxyList">
		<el-container>
			<el-header>
				<uiHeader></uiHeader>
			</el-header>
			<el-main>
				<div style="background-color: #FFFFFF; margin-bottom: 16px; position: relative; padding: 8px; text-align: left;">
					<!-- <span style="font-size: 16px; font-weight: bold;">拉流代理列表</span> -->
				</div>
				<div style="background-color: #FFFFFF; margin-bottom: 16px; position: relative; padding: 8px; text-align: left;font-size: .875rem;">
					<el-button icon="el-icon-plus" size="mini" style="margin-right: 16px;" type="primary" @click="addStreamProxy">添加内容</el-button>

					<el-form :inline="true" style="float: right;">

						<el-form-item label="类别：">
							<!-- <el-input v-model="content" placeholder="请输入类别"></el-input> -->
							<el-select v-model="content" placeholder="请选择" @focus="querySort">
								<el-option label="全部" value=""></el-option>
								<el-option
									v-for="item in restaurants"
									:key="item.value"
									:label="item.value"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" icon="el-icon-search" @click="queryList('first')">查询</el-button>
						</el-form-item>
					</el-form>

					<!-- <el-button v-if="false" icon="el-icon-search" size="mini" style="margin-right: 16px;" type="primary" @click="addOnvif">搜索ONVIF</el-button> -->
				</div>
				<!-- <devicePlayer ref="devicePlayer"></devicePlayer> -->
				<el-table :data="streamProxyList" border style="width: 100%" :height="winHeight">
					<el-table-column prop="category" label="类别" align="center" show-overflow-tooltip/>
					<el-table-column prop="title" label="标题" align="center" show-overflow-tooltip/>
					<el-table-column prop="subtitle" label="副标题" align="center" show-overflow-tooltip/>
					<el-table-column prop="showTime" label="展示时间" align="center" show-overflow-tooltip/>
					<el-table-column prop="sort" label="排序" align="center" show-overflow-tooltip/>
					<el-table-column label="封面" align="center">
						<template slot-scope="scope">
              <span v-if="scope.row.fileUrl == ''|| scope.row.fileUrl == null"></span>
              <el-image 
                v-else
                style="width: 3.125rem; height: 3.125rem"
                :src="scope.row.fileUrl" 
                :preview-src-list="[scope.row.fileUrl]">
              </el-image>
            </template>
					</el-table-column>

					<!-- <el-table-column prop="content" label="正文" align="center" show-overflow-tooltip/> -->
					<el-table-column prop="url" label="链接" align="center" show-overflow-tooltip/>
					<el-table-column prop="status" label="状态" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<span>{{scope.row.status == '0'?'停用':scope.row.status == '1'?'启用':''}}</span>
						</template>
					</el-table-column>

					<!-- <el-table-column label="正文" align="center" show-overflow-tooltip >
					</el-table-column>
          <el-table-column prop="mediaServerId" label="流媒体" width="150" align="center"></el-table-column>
          <el-table-column label="类型" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{scope.row.type}}</el-tag>
              </div>
            </template>
          </el-table-column>

					<el-table-column prop="gbId" label="国标编码" width="180" align="center" show-overflow-tooltip/>
          <el-table-column label="启用" width="120" align="center">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" v-if="scope.row.enable">已启用</el-tag>
                <el-tag size="medium" type="info" v-if="!scope.row.enable">未启用</el-tag>
              </div>
            </template>
          </el-table-column>
					<el-table-column label="转HLS" width="120" align="center">
						<template slot-scope="scope">
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium" v-if="scope.row.enable_hls">已启用</el-tag>
							<el-tag size="medium" type="info" v-if="!scope.row.enable_hls">未启用</el-tag>
						</div>
						</template>
					</el-table-column>
					<el-table-column label="MP4录制" width="120" align="center">
						<template slot-scope="scope">
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium" v-if="scope.row.enable_mp4">已启用</el-tag>
							<el-tag size="medium" type="info" v-if="!scope.row.enable_mp4">未启用</el-tag>
						</div>
						</template>
					</el-table-column>
					-->


					<el-table-column label="操作" width="360" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" type="primary" @click="using(scope.row)">{{scope.row.status == '0'?'启用':scope.row.status == '1'?'停用':''}}</el-button>
								<el-button size="mini" type="primary" @click="compile(scope.row)">编辑</el-button>
								<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
								<!-- <el-button size="mini" icon="el-icon-video-play" v-if="scope.row.enable" @click="play(scope.row)">播放</el-button> -->
								<!-- <el-button size="mini" icon="el-icon-close" type="success" v-if="scope.row.enable" @click="stop(scope.row)">停用</el-button> -->
								<!-- <el-button size="mini" icon="el-icon-check" type="primary" :loading="startBtnLaoding" v-if="!scope.row.enable" @click="start(scope.row)">启用</el-button> -->
								<!-- <el-button size="mini" icon="el-icon-delete" type="danger"  @click="deleteStreamProxy(scope.row)">删除</el-button> -->
							</el-button-group>
							</template>
					</el-table-column> 
				</el-table>
				<el-pagination
					style="float: right"
					@size-change="handleSizeChange"
					@current-change="currentChange"
					:current-page="currentPage"
					:page-size="count"
					:page-sizes="[15, 25, 35, 50]"
					layout="total, sizes, prev, pager, next"
					:total="total">
				</el-pagination>

				<el-dialog
					:title="isStutes == 1?'添加内容':'编辑内容'"
					width="46.875rem"
					:visible.sync="showDialog"
					@close="close()"
				>
					<div  >
						<el-form :model="proxyParam" label-width="6.25rem" >
							<el-form-item label="类别">
								<!-- <el-input v-model="proxyParam.stream" clearable></el-input> -->
								<el-autocomplete
									style="width:100%;"
									class="inline-input"
									v-model="proxyParam.stream"
									:fetch-suggestions="querySearch"
									placeholder="请输入类别"
									@select="handleSelect"
								></el-autocomplete>
							</el-form-item>
							<el-form-item label="标题">
								<el-input v-model="proxyParam.name" clearable></el-input>
							</el-form-item>
							<el-form-item label="副标题">
								<el-input v-model="proxyParam.subtitle" clearable></el-input>
							</el-form-item>
							<el-form-item label="展示时间">
								<!-- <el-input v-model="proxyParam.showTime" clearable placeholder="--年--月--日"></el-input> -->
								<el-date-picker
									style="width:100%;"
									v-model="proxyParam.showTime"
									type="date"
									placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="排序">
								<el-input v-model="proxyParam.app" clearable></el-input>
							</el-form-item>
							<el-form-item label="封面" prop="url">
								<!-- <el-input v-model="proxyParam.url" clearable></el-input> -->

								<el-upload
									action=""
									list-type="picture-card"
									:limit="1"
									:file-list="fileList"
									:before-upload="beforeAvatarUpload"
									:http-request="params => uploadLicense(params)"
									:on-preview="handlePictureCardPreview"
									:on-remove="handleRemove"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisibleImg" append-to-body>
									<img width="100%" :src="viewImg" alt="" />
								</el-dialog>
							</el-form-item>

							<el-form-item label="正文">
								<!-- <el-input v-model="proxyParam.src_url" clearable></el-input> -->
								<tinymce
									class="editorText"
									v-model="proxyParam.src_url"
									:height="150"
									isImage ="true"
									placeholder="请输入条款内容"
								></tinymce>
							</el-form-item>
							<el-form-item label="链接">
								<el-input v-model="proxyParam.timeout_ms" clearable></el-input>
							</el-form-item>
							<el-form-item label="状态" >
								<el-radio-group v-model="proxyParam.gbId">
									<el-radio label="1">启用</el-radio>
									<el-radio label="0">停用</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<div style="float: right;">
									<el-button type="primary" @click="onSubmit()">确定</el-button>
									<el-button @click="close">取消</el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</el-dialog>

			<!-- <streamProxyEdit ref="streamProxyEdit" ></streamProxyEdit> -->
			<!-- <onvifEdit ref="onvifEdit" ></onvifEdit> -->
			</el-main>
		</el-container>
	</div>
</template>

<script>
	// import streamProxyEdit from './dialog/StreamProxyEdit.vue'
	// import onvifEdit from './dialog/onvifEdit.vue'
	// import devicePlayer from './dialog/devicePlayer.vue'


//注掉
  import tinymce from "./tinymce/tinymce.vue";

	import uiHeader from './UiHeader.vue'
	export default {
		name: 'streamProxyList',
		components: {
    	tinymce,

			// devicePlayer,
			// streamProxyEdit,
      // onvifEdit,
			uiHeader
		},
		data() {
			return {
				showDialog: false,
				proxyParam: {
          name: '',
					subtitle: '',
					showTime: '',
          app: '',
          stream: '',
          url: "",
          src_url: '',
          timeout_ms: '',
          gbId: '1',
      	},

				streamProxyList: [],
				// currentPusher: {}, //当前操作设备对象
				// updateLooper: 0, //数据刷新轮训标志
				// currentDeviceChannelsLenth:0,
				winHeight: window.innerHeight - 250,
				currentPage:1,
				count:15,
				total:0,
				isStutes: 1,   // 1添加  2编辑
				id: '',
				// getListLoading: false,
				// startBtnLaoding: false
				fileList: [],
        dialogVisibleImg: false,
      	viewImg: "",
				content:'',
				restaurants: [],
			};
		},
		computed: {
		},
		mounted() {
			this.queryList()
			this.querySort()
			// this.initData();
			// this.updateLooper = setInterval(this.initData, 1000);
		},
		destroyed() {
			// this.$destroy('videojs');
			// clearTimeout(this.updateLooper);
		},
		methods: {
			// 列表
			queryList(first){
				if (first != undefined) {
					this.currentPage = 1
				}
				let that = this;
				this.$axios({
					method: 'post',
					url:"/api/content/selectAll",
					data: {
						pageNum: this.currentPage,
						pageSize: this.count,
						params:{
							category: this.content == ''?null:this.content,
						}
					}
				}).then(function (res) {
					console.log(res);
					that.streamProxyList = res.data.data.content
					that.total = res.data.data.totalSize
				})
			},


			// initData: function() {
			// 	this.getStreamProxyList();
			// },
			// 分页
			currentChange(val){
				this.currentPage = val;
				this.queryList();
			},
			// 条数
			handleSizeChange(val){
				this.count = val;
				this.queryList();
			},
			// 请求类别
			querySort(){
				let that = this;
				that.restaurants = []
				this.$axios({
					method: 'get',
					url:"/api/content/selectContentCategory",
				}).then(function (res) {
					console.log(res);
					for (let i = 0; i < res.data.data.length; i++) {
						let str = {
							value:res.data.data[i]
						}
						that.restaurants.push(str)
					}
					console.log(that.restaurants);
				})
			},
			querySearch(queryString, cb) {
				console.log(queryString);
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
			 createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
			handleSelect(item) {
        console.log(item);
      },
			// getStreamProxyList: function() {
			// 	let that = this;
			// 	this.getListLoading = true;
			// 	this.$axios({
			// 		method: 'get',
			// 		url:`/api/proxy/list`,
			// 		params: {
			// 			page: that.currentPage,
			// 			count: that.count
			// 		}
			// 	}).then(function (res) {
			// 		that.total = res.data.total;
			// 		that.streamProxyList = res.data.list;
			// 		that.getListLoading = false;
			// 	}).catch(function (error) {
			// 		console.log(error);
			// 		that.getListLoading = false;
			// 	});
			// },
			// 添加内容弹窗
			addStreamProxy(){
				this.isStutes = 1
				this.showDialog = true;
				this.querySort()
				// this.$refs.streamProxyEdit.openDialog(null, this.initData)
			},
			//时间转换
			formateDate(timestamp){
				// console.log(timestamp);
				let a = new Date(timestamp).getTime();
				// let b = 8*60*60*1000
				// console.log(b);
				// console.log(a);
				const date = new Date(a);
				console.log(date);
				const Y = date.getFullYear() + '-';
				const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				const D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '  ';
				// const s = date.getSeconds(); // 秒
				const dateString = Y + M + D;
				// console.log('dateString', dateString); // > dateString 2021-07-06 14:23
				return dateString;
			},
			// 添加内容
			onSubmit() {
				console.log(this.fileList,this.proxyParam);
				let that = this
				let fromData = {
					title: this.proxyParam.name,
					subtitle: this.proxyParam.subtitle,
					showTime: this.proxyParam.showTime == ''?this.proxyParam.showTime:this.proxyParam.showTime == null?'':this.formateDate(this.proxyParam.showTime),
					sort: this.proxyParam.app,
					category: this.proxyParam.stream,
					fileUrl: this.fileList.length == 0?'':this.fileList[0].url,
					content: this.proxyParam.src_url,
					url: this.proxyParam.timeout_ms,
					status: this.proxyParam.gbId,
				}
				// 添加
				if (this.isStutes == 1) {
					this.$axios({
						method: 'post',
						url:`api/content/add`,
						data: fromData
					}).then(function (res) {
						console.log(res);
						if (res.status == 200) {
							that.$message.success('添加成功')
							that.showDialog = false
							that.queryList()
						}
					})
					// 编辑
				}else if (this.isStutes == 2) {
					fromData.id = this.id
					this.$axios({
						method: 'post',
						url:`api/content/update`,
						data: fromData
					}).then(function (res) {
						console.log(res);
						if (res.status == 200) {
							that.$message.success('编辑成功')
							that.showDialog = false
							that.queryList()
						}
					})
				}
				
			},
			// 清除
			close(){
				this.showDialog = false;
				this.proxyParam.name = ''
				this.proxyParam.subtitle = '',
				this.proxyParam.showTime = '',
				this.proxyParam.app = ''
				this.proxyParam.stream = ''
				this.proxyParam.url = ''
				this.proxyParam.src_url = ''
				this.proxyParam.timeout_ms = ''
				this.proxyParam.gbId = '1'
				this.fileList = []
				// this.dialogLoading = false;
				// this.$refs.streamProxy.resetFields();
			},
			// 删除
			del(row){
				let that = this
				this.$axios({
					method: 'post',
					url:`api/content/update`,
					data: {
						id: row.id,
						isDel: '1'
					}
				}).then(function (res) {
					console.log(res);
					if (res.status == 200) {
						that.$message.success('删除成功')
						that.queryList()
					}
				})
			},
			// 启用停用
			using(row){
				let that = this
				this.$axios({
					method: 'post',
					url:`api/content/update`,
					data: {
						id: row.id,
						status: row.status == 0?'1':row.status == 1?'0':'',
					}
				}).then(function (res) {
					console.log(res);
					if (res.status == 200) {
						that.$message.success(row.status == 0?'启用成功':row.status == 1?'停用成功':'')
						that.queryList()
					}
				})
			},
			// 编辑
			compile(row){
				this.id = row.id
				let that = this
				this.$axios({
					method: 'get',
					url:`api/content/selectContentById`,
					params: {
						id:row.id
					}
				}).then(function (res) {
					console.log(res);
					if (res.status == 200) {
						that.isStutes = 2
						that.proxyParam.name = res.data.data.title
						that.proxyParam.subtitle = res.data.data.subtitle
						that.proxyParam.showTime = res.data.data.showTime
						that.proxyParam.app = res.data.data.sort
						that.proxyParam.stream = res.data.data.category
						if (res.data.data.fileUrl != '') {
							that.fileList.push({ url: res.data.data.fileUrl })
						}
						// that.proxyParam.url = res.data.data.fileUrl,
						that.proxyParam.src_url = res.data.data.content
						that.proxyParam.timeout_ms = res.data.data.url
						that.proxyParam.gbId = res.data.data.status
						that.showDialog = true
					}
				})
				this.querySort()
			},


			beforeAvatarUpload(file) {
      var isJPG = false;
      switch (file.type) {
        case "image/png":
          isJPG = true;
          break;
        case "image/jpeg":
          isJPG = true;
          break;
        default:
          isJPG = false;
          break;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isJPG && isLt10M;
    },
    uploadLicense(params) {
      const file = params.file;

      const form = new FormData();
      form.append("file", file);

			let that = this
			this.$axios({
				method: 'post',
				url:`/api/content/upload`,
				data: form,
			}).then(function (res) {
				console.log(res);
				that.fileList.push({ url: res.data.data });
			})
    },
    // 删除图片
    handleRemove(file) {
			console.log(this.fileList,file);
      let arr = this.fileList;
      let num = 0;
      for (let item in arr) {
        if (arr[item].url == file.url) {
          num = item;
        }
      }
      this.fileList.splice(num, 1);
    },
    // 查看图片
    handlePictureCardPreview(file) {
      this.viewImg = file.url;
      this.dialogVisibleImg = true;
    },
			
      // addOnvif: function(){
      //   this.getListLoading = true;
      //   this.getListLoading = true;
      //   this.$axios({
      //     method: 'get',
      //     url:`/api/onvif/search?timeout=3000`,
      //   }).then((res) =>{
      //     this.getListLoading = false;
      //     if (res.data.code == 0 ){
      //       if (res.data.data.length > 0) {
      //         this.$refs.onvifEdit.openDialog(res.data.data, (url)=>{
      //             if (url != null) {
      //               this.$refs.onvifEdit.close();
      //               this.$refs.streamProxyEdit.openDialog({type: "default", url: url, src_url: url}, this.initData())
      //             }
      //         })
      //       }else {
      //         this.$message.success("未找到可用设备");
      //       }
      //   }else {
      //       this.$message.error(res.data.msg);
      //     }

      //   }).catch((error)=> {
      //     this.getListLoading = false;
      //     this.$message.error(error.response.data.msg);
      //   });

			// },
			// saveStreamProxy: function(){
			// },
			// play: function(row){
			// 	let that = this;
			// 	this.getListLoading = true;
			// 	this.$axios({
			// 		method: 'get',
			// 		url:`/api/media/stream_info_by_app_and_stream`,
			// 		params: {
			// 			app: row.app,
			// 			stream: row.stream,
      //       mediaServerId: row.mediaServerId
			// 		}
			// 	}).then(function (res) {
			// 		that.getListLoading = false;
			// 		if (res.data.code === 0) {
      //       that.$refs.devicePlayer.openDialog("streamPlay", null, null, {
      //         streamInfo: res.data.data,
      //         hasAudio: true
      //       });
      //     }else {
      //       that.$message({
      //         showClose: true,
      //         message: "获取地址失败：" + res.data.msg,
      //         type: "error",
      //       });
      //     }

			// 	}).catch(function (error) {
			// 		console.log(error);
			// 		that.getListLoading = false;
			// 	});

			// },
			// deleteStreamProxy: function(row){
			// 	let that = this;
			// 	this.getListLoading = true;
			// 	that.$axios({
      //               method:"delete",
      //               url:"/api/proxy/del",
      //               params:{
      //                 app: row.app,
      //                 stream: row.stream
      //               }
      //           }).then((res)=>{
      //               that.getListLoading = false;
			// 		          that.initData()
      //           }).catch(function (error) {
      //               console.log(error);
			// 		          that.getListLoading = false;
      //           });
			// },
			// start: function(row){
			// 	let that = this;
			// 	this.getListLoading = true;
			// 	this.startBtnLaoding = true;
			// 	this.$axios({
			// 		method: 'get',
			// 		url:`/api/proxy/start`,
			// 		params: {
			// 			app: row.app,
			// 			stream: row.stream
			// 		}
			// 	}).then(function (res) {
      //     that.getListLoading = false;
      //     that.startBtnLaoding = false;
			// 	  if (res.data == "success"){
      //       that.initData()
      //     }else {
      //       that.$message({
      //         showClose: true,
      //         message: "保存失败，请检查地址是否可用！",
      //         type: "error",
      //       });
      //     }

			// 	}).catch(function (error) {
			// 		console.log(error);
			// 		that.getListLoading = false;
			// 		that.startBtnLaoding = false;
			// 	});
			// },
			// stop: function(row){
			// 	let that = this;
			// 	this.getListLoading = true;
			// 	this.$axios({
			// 		method: 'get',
			// 		url:`/api/proxy/stop`,
			// 		params: {
			// 			app: row.app,
			// 			stream: row.stream
			// 		}
			// 	}).then(function (res) {
			// 		that.getListLoading = false;
			// 		that.initData()
			// 	}).catch(function (error) {
			// 		console.log(error);
			// 		that.getListLoading = false;
			// 	});
			// }

		}
	};
</script>

<style>
.el-upload__input{
	display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/StreamProxyList.vue